<template>
    <form action="" id="form_filter">
        
        <b-form-group id="selectCityGroup"
                    label="Selecciona tu localización"
                    label-for="selectCity">
            <b-form-select id="selectDpto"
                class="mb-3" 
                size="sm"
                :options="departmentsCombo"
                v-model="selectedDepartment"
                required
                @input="onChangeComboDepartment">
            </b-form-select>
            <!-- Cities -->
            <b-form-select id="selectCity"
                class="mb-3" 
                size="sm"
                :options="citiesCombo"
                v-model="selectedCity"
                required
                @input="onChangeComboCity">
            </b-form-select>
        </b-form-group>
        <!-- Categories -->
        <b-form-group label="Selecciona Productos y Servicios" id="categoriesList">
            <b-form-checkbox-group  id="checkboxCategories" name="categories" v-model="selectedCategories">
                <b-form-checkbox  
                    v-for="category in categories" 
                    v-bind:key="category.id_cat" 
                    :value="category.id_cat">
                        {{ category.nombre }}
                </b-form-checkbox>
            </b-form-checkbox-group>
        </b-form-group>
        <b-button size="sm" @click="searchPoints">Buscar</b-button>
    </form>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import consumer from "@/modules/consumer";
import { EventBus } from '@/modules/events';
import Geocoder from '@/modules/google/Geocoder';

const userMarkerIcon = require("@/assets/images/bluecircle.png");
const puntoRedIcon = require("@/assets/images/pin-ubicacion.png");
const defaultImage = require("@/assets/images/default.gif");

export default {
  name: "FormFilter",
  data() {
    return {
      cities: [],
      status: false,
      selectedCategories: [],
      selectedDepartment: null,
      selectedCity: null,
      show: true
    };
  },
  computed: {
    ...mapState({
      citiesLoc: state => state.cities.cities,
      departments: state => state.departments.departments,
      categories: state => state.categories.categories,
      wasLoadedByPosition: state => state.points.loadedByPosition,
    }),
    ...mapGetters("interface", {
      isDimensionResponsive: "isDimensionResponsive"
    }),
    citiesCombo() {
      var combo = this.cities.map(c => ({ value: c.code, text: c.name }));
      return [{ value: null, text: "Selecciona una ciudad" }, ...combo];
    },
    departmentsCombo() {
      var combo = this.departments.map(d => ({ value: d, text: d }));
      return [{ value: null, text: "Selecciona un departamento" }, ...combo];
    }
  },
  mounted() {
      EventBus.$on('getCurrentPositionPoints', this.getCurrentPositionPoints);

      /**
      *
      */
      if (!this.wasLoadedByPosition){
          setTimeout(this.getCurrentPositionPoints, 2000);      
          this.setLoadedByPosition();
      }        
  },
  methods: {
    hideSideBarInResponsive() {
      if (this.isDimensionResponsive) {
        this.hideSidebar();
      }
    },
    onChangeComboDepartment(){
      if (!this.selectedDepartment) {
        return;
      }
      consumer.getCitiesDepartment(this.selectedDepartment).then(resp => {
        this.selectedCity = null;
        this.cities = resp.data.data.cities;
      });
    },
    onChangeComboCity() {
      if (!this.selectedCity) {
        return;
      }
      var city = this.citiesLoc.find(c => c.codigo == this.selectedCity);
      if (city) {
        window.mapInstance.setCenter(
          parseFloat(city.lng),
          parseFloat(city.lat),
          parseInt(city.zoom)
        );
      }
    },
    getCurrentPositionPoints() {
      var self = this;
      new Geocoder().currentPosition(locationObj => {
        const {latitude, longitude} = locationObj.coords;
        window.mapInstance.showUserMarker(parseFloat(latitude), parseFloat(longitude), userMarkerIcon);
        consumer.
          getPointsAround(longitude, latitude, 10)
          .then(resp => {
            var points = resp.data.data.results;
            self.paintPoints(points);
          });
      });
    },
    searchPoints() {
      if (!this.selectedCity) {
        alert("Seleccione una Ciudad");
        return;
      }
      consumer
        .getPointsCity(this.selectedCity)
        .then(resp => {
          var filters = this.filterPointsCategories(resp.data.data.results);
          if (filters.length == 0) {
            alert("No se encontrator resultados");
            return;
          }
          this.paintPoints(filters);
        })
        .catch(e => {
          if (e && e.response && e.response.status == 404) {
            alert("No se encontró datos asociados a la consulta");
          }
        });
    },
    filterPointsCategories(points) {
      var selectedCategories = this.selectedCategories;
      if (selectedCategories.length == 0) return points;
      var results = [];
      points.forEach(p => {
        var pCatg = p.tipo_servicio.split(",");
        for (var i in selectedCategories) {
          if (pCatg.indexOf(selectedCategories[i] + "") >= 0) {
            results.push(p);
          }
        }
      });
      return results;
    },
    paintPoints(points) {
      window.mapInstance.cleanAllMarkers();
      window.mapInstance.cleanPolygons();
      var bounds = window.mapInstance.createBounds();
      var validPoints = false;
      for (var i in points) {
        var point = points[i];
        const {cx, cy} = point;
        if(cx && cy){
          var latLng = {
            lat: parseFloat(point.cy),
            lng: parseFloat(point.cx)
          };
          bounds.extend(latLng);
          this.paintPoint(latLng, point);
          validPoints = true;
        }        
      }
      if(validPoints)
        window.mapInstance.fitBounds(bounds);
      this.hideSideBarInResponsive();
    },
    paintPoint(latLng, point) {
      window.mapInstance.addMarker(point.puntored_id, latLng, {
        icon: puntoRedIcon,
        title: point.nombre_comercial,
        infowin: this.infowinPoint(point),
        markerOptions: {
          zIndex: 100
        }
      });
    },
    infowinPoint({
      direccion,
      imagen,
      nombre_ciudad,
      nombre_comercial,
      nombre_departamento,
      horario,
      cx,
      cy
    }) {
      if (!imagen) {
        imagen = defaultImage;
      }
      if (!nombre_comercial) {
          nombre_comercial = direccion;
      }
      return `
          <div class="infowin_point">
            <h1>${nombre_comercial}</h1>
            <figure>
                <img src="${imagen}" alt="Imagen del punto"/>
            </figure>
            <ul>
                <li>
                  <strong>Dirección: </strong>
                  <span>${direccion}</span>
                </li>
                <li>
                  <strong>Horario: </strong>
                  <span>${horario}</span>
                </li>
                <li>
                  <strong>Ciudad: </strong>
                  <span>${nombre_ciudad}</span>
                </li>
                <li>
                  <strong>Departamento: </strong>
                  <span>${nombre_departamento}</span>
                </li>
                <li>
                  <button 
                    type="button" 
                    class="btn-gmaps btn btn-primary btn-sm"
                    onclick="OpenInGoogleMaps(${cy},${cx})"
                    >Ver en Google Maps</button>
                </li>
            </ul>
          </div>
      `;
    },
    ...mapActions("interface", {
      hideSidebar: "hideSidebar",
      showSidebar: "showSidebar"
    }),
    ...mapActions("points", {
      setLoadedByPosition: "setLoadedByPosition"
    })
  }
};
</script>
<style lang="scss">
@import "@/assets/css/constants.scss";
br {
  height: 10px;
}

#form_filter {
  max-height: 90%;
  overflow-y: auto;

  strong {
    color: #7a848b;
    font-size: $font-size - 0.25;
    font-weight: $font-weight + 100;
  }

  .form-group {
    label {
      font-size: $font-size - 0.2;
    }
  }
}

#categoriesList {
  list-style: none;
  max-height: 30%;
  overflow-y: auto;

  legend {
    color: #373a3c;
    font-size: $font-size - 0.1;
    font-weight: $font-weight;
    line-height: 2;
  }

  label {
    font-size: $font-size;
    font-weight: $font-weight - 100;
    line-height: 2;
  }
}

#selectCityGroup {
  margin-top: 20px;
}

#checkboxCategories {
  .custom-control {
    display: block;
  }
}
</style>

